export default "<app-logoconsota></app-logoconsota>\n\n<router-outlet></router-outlet>"